/**
 * Converts hex color to a background version with adjusted opacity
 * @param hexColor - Hex color code (with or without # prefix)
 * @param opacity - Opacity value between 0 and 1 (default: 0.2)
 * @returns Hex color for background
 */
export const generateBackgroundColor = (hexColor: string, opacity: number = 0.2): string => {
  try {
    // Remove # if present
    const hex = hexColor.replace('#', '')

    // Parse the hex color
    const r = parseInt(hex.substring(0, 2), 16)
    const g = parseInt(hex.substring(2, 4), 16)
    const b = parseInt(hex.substring(4, 6), 16)

    // Calculate perceived brightness (using the luminance formula)
    const brightness = (0.299 * r + 0.587 * g + 0.114 * b) / 255

    let backgroundR, backgroundG, backgroundB

    if (brightness > 0.7) {
      // For bright colors, make background moderately darker
      // Using a formula that darkens less severely: mix with black using a softer ratio
      const darkenFactor = 0.6 // Less darkening (higher = less dark)
      backgroundR = Math.round(r * darkenFactor)
      backgroundG = Math.round(g * darkenFactor)
      backgroundB = Math.round(b * darkenFactor)
    } else {
      // For darker colors, make background lighter
      backgroundR = Math.round(r + (255 - r) * (1 - opacity))
      backgroundG = Math.round(g + (255 - g) * (1 - opacity))
      backgroundB = Math.round(b + (255 - b) * (1 - opacity))
    }

    // Convert back to hex
    return `#${backgroundR.toString(16).padStart(2, '0')}${backgroundG
      .toString(16)
      .padStart(2, '0')}${backgroundB.toString(16).padStart(2, '0')}`
  } catch (error) {
    return '#000000'
  }
}
